import { IRestaurantDetail } from "../models/IRestaurantDetail";
import { S3_IMAGE_BASE_URL } from "../services/config";
import { useLanguage } from "../context/LanguageContext";

interface Props {
  restaurant: IRestaurantDetail;
  isFavorite: boolean;
  onToggleFavorite: () => void;
  favoriteLoading: boolean;
  loggedIn: boolean;
}

function RestaurantHeader({ restaurant, isFavorite, onToggleFavorite, favoriteLoading, loggedIn }: Props) {
  const { t } = useLanguage();

  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h2 className="fw-bold mb-0">{restaurant.restourantName}</h2>
        {loggedIn && <button
          className="btn p-0 border-0 bg-transparent"
          onClick={onToggleFavorite}
          disabled={favoriteLoading}
          aria-label={isFavorite ? "Favorilerden çıkar" : "Favorilere ekle"}
          style={{ lineHeight: 1 }}
        >
          <i
            className={`bi ${isFavorite ? "bi-heart-fill" : "bi-heart"}`}
            style={{ fontSize: "1.6rem", color: "#c20e1a", transition: "transform 0.15s", transform: favoriteLoading ? "scale(0.85)" : "scale(1)" }}
          />
        </button>}
      </div>

      {restaurant.restourantFeatureadImagePath && (
        <img
          src={S3_IMAGE_BASE_URL + restaurant.restourantFeatureadImagePath}
          alt={restaurant.restourantName}
          className="w-100 mb-4"
          style={{ borderRadius: "20px", maxHeight: "300px", objectFit: "cover" }}
        />
      )}

      <div className="row g-3 mb-4">
        <div className="col-4">
          <div className="bg-white rounded-3 shadow-sm p-3 text-center">
            <i className="bi bi-alarm fs-4 text-danger"></i>
            <div className="fw-semibold mt-1">{restaurant.restourantEstDeliveryTime} {t("common.minutes")}</div>
            <small className="text-muted">{t("restaurants.deliveryTime")}</small>
          </div>
        </div>
        <div className="col-4">
          <div className="bg-white rounded-3 shadow-sm p-3 text-center">
            <i className={`bi ${restaurant.restourantIsEnabled ? "bi-door-open text-success" : "bi-door-closed text-danger"} fs-4`}></i>
            <div className="fw-semibold mt-1">
              {restaurant.restourantIsEnabled ? t("restaurants.open") : t("restaurants.closed")}
            </div>
            <small className="text-muted">{t("restaurants.status")}</small>
          </div>
        </div>
        <div className="col-4">
          <div className="bg-white rounded-3 shadow-sm p-3 text-center">
            <i className="bi bi-cash fs-4 text-warning"></i>
            <div className="fw-semibold mt-1">{restaurant.restourantMinAmount} ₺</div>
            <small className="text-muted">{t("restaurants.minOrder")}</small>
          </div>
        </div>
      </div>
    </>
  );
}

export default RestaurantHeader;
